import script from "./address-edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./address-edit.vue?vue&type=script&lang=ts&setup=true"

import "./address-edit.vue?vue&type=style&index=0&id=ba7599d6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba7599d6"]])

export default __exports__